import script from "./CollectionCommunityActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCommunityActivity.vue?vue&type=script&setup=true&lang=js"

import "./CollectionCommunityActivity.vue?vue&type=style&index=0&id=e8098718&lang=scss"

const __exports__ = script;

export default __exports__